module.exports = "../images/homepage/type-race.svg";